import { createStore } from 'vuex'
// import axios from 'axios'
import { Vm } from '@bluepjs/vm'
import DemoActor from '@/actor'
import PageModule from '@/vm/page.module'
import DB from '../../db.json'

// const apiUrl = 'http://localhost:8008'

export default createStore({
  state: {
    vm: {
      types: {},
      nodes: [],
      libraries: {},
      modules: {},
      actors: {}
    }
  },
  mutations: {
    setVm (ctx, next) {
      ctx.vm = next
    },
    setLibs: (ctx, next) => {
      ctx.vm.libraries = next
    }
  },
  actions: {
    async init (ctx) {
      const vm = new Vm()
      // const data = await axios.get(`${apiUrl}/vm`)
      vm.addModule(PageModule)
      // await vm.M('page').init(this.$refs.demo.children)
      const demoActor = new DemoActor('90df7b49-7f94-4ac7-9bec-3193f20908b9')
      // and add actor to virtual machine
      vm.M('actor').addActor(demoActor)

      const data = vm.ideData()
      // let's display it in console for easy inspecting
      console.log('vm.ideData() for inspect', data)
      const jlibs = localStorage.getItem('bluepjs/example/libs')
      const libs = jlibs ? JSON.parse(jlibs) : DB.libraries
      ctx.commit('setVm', data)
      ctx.commit('setLibs', libs)
    },
    async saveAll (ctx, libs) {
      // await axios.post(`${apiUrl}/libraries/save`, { libraries: libs })
      localStorage.setItem('bluepjs/example/libs', JSON.stringify(libs))
      ctx.commit('setLibs', libs)
      await ctx.dispatch('init')
    },
    async runFunction (ctx, info) {
      console.log('runfn', info)
      // const data = await axios.get(`${apiUrl}/run/${info.library}/${info.code}`)
      // return data.data
    }
  }
})
